import { render } from "./PublicAdd.vue?vue&type=template&id=80d0d9ee&scoped=true"
import script from "./PublicAdd.vue?vue&type=script&lang=js"
export * from "./PublicAdd.vue?vue&type=script&lang=js"

import "./PublicAdd.vue?vue&type=style&index=0&id=80d0d9ee&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-80d0d9ee"]])

export default __exports__